import "./Sidebar.scss";
import { brand, brandLogos } from "../../brand";
import calendar from "../../assets/calendar.svg";
import logoutIcon from "../../assets/logout.svg";
import dashboard from "../../assets/dashboard.svg";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { useEffect } from "react";

const Sidebar = (): JSX.Element => {
  const { enrolments, fetchEnrolments, logout } = useUser();
  const location = useLocation();
  const practiceSubjectId =
    location.pathname.startsWith("/practice") &&
    location.state?.practiceSubjectId != null &&
    location.state.practiceSubjectId !== ""
      ? String(location.state.practiceSubjectId)
      : null;

  useEffect(() => {
    const fetchEnrolmentsIfNotAlreadyLoaded = async () => {
      await fetchEnrolments();
    };
    if (enrolments.length === 0) {
      fetchEnrolmentsIfNotAlreadyLoaded();
    }
  }, []);

  const now = new Date();
  const day = now.toLocaleDateString("en-US", { day: "numeric" });
  const monthYear = now.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });

  return (
    <div id="sidebarWrapper">
      <aside className="sidebar">
        <div className="sidebar__logo">
          <Link to="/dashboard">
            <img src={brandLogos.white} alt={brand.displayName} />
          </Link>
        </div>

        <nav className="sidebar__nav">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `sidebar__link${isActive ? " is-active" : ""}`
            }
          >
            <span className="sidebar__icon">
              <img src={dashboard} alt="" />
            </span>
            <span className="sidebar__label">Dashboard</span>
          </NavLink>

          {enrolments.length > 0 && (
            <div className="sidebar__divider">
              <span>Your banks</span>
            </div>
          )}

          {enrolments.map((e) => {
            const isPracticeActive =
              practiceSubjectId !== null &&
              practiceSubjectId === String(e.subjectId);

            return (
              <NavLink
                key={e.subjectId}
                to={`/subjects/${e.subjectId}`}
                className={({ isActive }) =>
                  `sidebar__link sidebar__link--course${
                    isActive || isPracticeActive ? " is-active" : ""
                  }`
                }
              >
                <span className="sidebar__label">{e.className}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="sidebar__footer">
          <button
            type="button"
            className="sidebar__link sidebar__link--logout"
            onClick={logout}
          >
            <span className="sidebar__icon sidebar__icon--muted">
              <img src={logoutIcon} alt="" />
            </span>
            <span className="sidebar__label">Log out</span>
          </button>

          <div className="sidebar__calendar">
            <img src={calendar} alt="" className="sidebar__calendar-icon" />
            <span className="sidebar__calendar-day">{day}</span>
            <span className="sidebar__calendar-date">{monthYear}</span>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
